module.exports = __webpack_public_path__ + "static/Bedroom_music_View090000_-min-be1b68dbd4cf4034300cc313d62349b3.png";